import './AboutLanding.css'
import { FC, useContext } from "react"
import { Flex } from 'antd'
import { ResponsiveContext } from '../../context/responsive-context'
import { TransparentButton } from '../../common-components/CustomButtons'

export const AboutLanding: FC = () => {
  const { useVertical } = useContext(ResponsiveContext)
  return (
    <>
    { !useVertical &&
    <Flex className="About-landing-container" justify={'space-evenly'}>
    <Flex vertical justify={'space-evenly'} style={{ height: '100%', width: '50%'}} gap={140}>
      <Flex className="About-landing-body" justify={'center'} align={'end'}>Érdekel, miért választottam ezt a szakmát?</Flex>
      <Flex className="About-landing-button-container" justify={'center'} >
          <TransparentButton
          href='#about'
          >
            {"ELOLVASOM A TÖRTÉNETED"}
          </TransparentButton>
      </Flex>
    </Flex>
    <Flex style={{height: '100%', width: '50%' }} justify={'center'} align={'center'}>
        <img className="About-landing-pic" src='https://storage.googleapis.com/simonadelstyle/about-pic.jpeg' />
    </Flex>
    </Flex>
    }
    { useVertical &&
    <Flex className="About-landing-container" vertical >
      <Flex style={{height: '50%', width: '100%' }} justify={'center'} align={'center'}>
          <img className="About-landing-pic-vertical" src='https://storage.googleapis.com/simonadelstyle/about-pic.jpeg' />
      </Flex>
      <Flex style={{height: '50%', width: '100%' }} vertical gap={20}>
        <Flex className="About-landing-body-vertical" justify={'center'} align={'end'}>Érdekel, miért választottam ezt a szakmát?</Flex>
        <Flex className="About-landing-button-container" justify={'center'} >
            <TransparentButton
            href='#about'
            >
              {"ELOLVASOM A TÖRTÉNETED"}
            </TransparentButton>
        </Flex>
      </Flex>
    </Flex>
    }
    </>
  )
}
